import { ListeTable } from '@mairistem/liste';

const ReglementCarteBancaireInternetListeTableHeader = (props) => (
  <>
    <ListeTable.Column {...props} name="numeroRecu" style={{ width: 175 }} verticalAlign="middle">
      N° de reçu
    </ListeTable.Column>
    <ListeTable.Column {...props} name="dateRecu" style={{ width: 120 }} verticalAlign="middle">
      Date
    </ListeTable.Column>
    <ListeTable.Column {...props} name="nomPayeur" verticalAlign="middle">
      Nom du payeur
    </ListeTable.Column>
    <ListeTable.Column {...props} name="montant" style={{ width: 140 }} verticalAlign="middle">
      Montant
    </ListeTable.Column>
  </>
);

export default ReglementCarteBancaireInternetListeTableHeader;
